<template>
    <div class="dashboard__cards" ref="dashboard_card_parent">
        <div class="card card--with-heading">
            <div class="chart-wrapper">
                <div id="chart2">
                    <h4 class="card-header card-title">Cantidad Total</h4>

                    <apexchart
                        v-show="!isLoading && !noData"
                        ref="quantityGraph"
                        type="bar"
                        :options="chartOptions"
                        :series="series"
                    ></apexchart>
                    <div v-show="!isLoading && noData" class="alert info">
                        <vs-icon icon="info"></vs-icon>
                        <span
                            >No existe suficiente información para mostrar la
                            cantidad.</span
                        >
                    </div>

                    <div v-show="isLoading">
                        <!-- Acá iria algo para cuando este cargando. Un skeleton o un spinner -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
    name: "market-quantity-chart",
    components: {
        apexchart: VueApexCharts,
    },
    components: {
        apexchart: VueApexCharts,
    },
    props: {
        graphData: Object,
        barSize: {
            type: String,
            required: true,
        },
        isLoading: {
            type: Boolean,
            default: true,
            required: false,
        },
    },
    data() {
        return {
            noData: false,
            series: [
                {
                    name: "Origen",
                    data: [0],
                },
                {
                    name: "Destino",
                    data: [0],
                },
            ],
            chartOptions: {
                chart: {
                    type: "bar",
                    width: "100%",
                    height: 350,
                    stacked: true,
                    toolbar: {
                        show: false,
                    },
                    zoom: {
                        enabled: false,
                    },
                },

                stroke: {
                    show: true,
                    colors: ["#000000"],
                    curve: "straight",
                    lineCap: "straight",
                    width: 1,
                },
                colors: ["#d2736d", "#3d92d9"],
                xaxis: {
                    type: "category",
                    tickPlacement: "between",
                },
                legend: {
                    show: true,
                    onItemClick: {
                        toggleDataSeries: true,
                    },
                    position: "bottom",
                    offsetY: 5,
                },
                fill: {
                    opacity: 1,
                },
                dataLabels: {
                    enabled: false,
                    style: {
                        colors: ["#ffffff"],
                    },
                },
                tooltip: {
                    followCursor: false,
                    shared: false,
                    custom: function ({
                        series,
                        seriesIndex,
                        dataPointIndex,
                        w,
                    }) {
                        return `
                            <div style="padding: 10px">
                                <div>
                                    Total: ${
                                        series[0][dataPointIndex] +
                                        series[1][dataPointIndex]
                                    } <br>
                                </div>
                                <span>
                                    
                                    <span class="apexcharts-legend-marker" rel="1"
                                        style="background: rgb(61, 146, 217) !important; color: rgb(61, 146, 217); height: 12px; width: 12px; left: 0px; top: 0px; border-width: 0px; border-color: rgb(255, 255, 255); border-radius: 2px;"
                                    ></span>
                                    Destino: <b> ${
                                        series[1][dataPointIndex] != null
                                            ? series[1][dataPointIndex]
                                            : 0
                                    }  </b><br>

                                    <span class="apexcharts-legend-marker" rel="1"
                                        style="background: rgb(210, 115, 109) !important; color: rgb(210, 115, 109); height: 12px; width: 12px; left: 0px; top: 0px; border-width: 0px; border-color: rgb(255, 255, 255); border-radius: 2px;"
                                    ></span>
                                    Origen: <b> ${
                                        series[0][dataPointIndex] != null
                                            ? series[0][dataPointIndex]
                                            : 0
                                    } </b><br>

                                    
                                </span>
                            </div>`;
                    },
                },

                plotOptions: {
                    bar: {
                        columnWidth: "10%",
                        borderRadius: 2,
                        horizontal: false,
                    },
                },
            },
        };
    },
    methods: {
        redrawChart() {
            this.chartOptions.plotOptions.bar.columnWidth = this.barSize;

            this.$refs.quantityGraph.updateOptions(
                this.chartOptions,
                true,
                true
            );
        },
    },
    watch: {
        graphData: function (newVal, oldVal) {
            if (newVal && newVal.marketGraphDashboard) {
                let newSeries = newVal.marketGraphDashboard.graphValues.map(
                    (obj) => {
                        return {
                            x: `${obj.week
                                .toString()
                                .substring(
                                    0,
                                    4
                                )}-${obj.week.toString().substring(4, 6)} `,
                            quantityAtDestination: obj.quantityAtDestination,
                            quantityAtOrigin: obj.quantityAtOrigin,
                        };
                    }
                );

                this.series = [
                    {
                        name: "Origen",
                        data: newSeries.map((e) => e.quantityAtOrigin),
                    },
                    {
                        name: "Destino",
                        data: newSeries.map((e) => e.quantityAtDestination),
                    },
                ];

                this.chartOptions.xaxis.categories = newSeries.map((e) => e.x);

                let originEmpty =
                    this.series[0].data.filter((elem) => elem != 0).length == 0;
                let destinationEmpty =
                    this.series[1].data.filter((elem) => elem != 0).length == 0;

                if (originEmpty && destinationEmpty) {
                    this.noData = true;
                } else {
                    this.noData = false;
                }

                this.redrawChart();
            }
        },
    },
};
</script>
<style scoped>
.card-header {
    margin-left: -16px;
}
</style>
